import React, { Component, ReactNode, createRef } from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  DropdownWrapper,
  DropdownList,
  DropdownListItem,
} from "./styles/action-bar-options-cog-styles";

interface IDropdownItemProps {
  id: number;
  label: string;
  action?: () => void;
}

interface IActionBarOptionsCogProps {
  data: Array<IDropdownItemProps>;
}

interface IActionBarOptionsCogState {
  dropdownActive: boolean;
}

class ActionBarOptionsCog extends Component<
  IActionBarOptionsCogProps,
  IActionBarOptionsCogState
> {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        label: PropTypes.string,
      })
    ).isRequired,
  };

  private optionsDropdown = createRef<HTMLDivElement>();

  state = {
    dropdownActive: false,
  };

  componentDidMount(): void {
    this.handleDropdownOutsideClick();
  }

  componentWillUnmount(): void {
    this.handleDropdownOutsideClick();
  }

  handleOptionsCog = (): void => {
    const { dropdownActive } = this.state;

    this.setState(() => ({
      dropdownActive: !dropdownActive,
    }));
  };

  handleDropdownOutsideClick = (): void => {
    document.addEventListener("click", (e) => {
      const { dropdownActive } = this.state;
      const dropdown = this.optionsDropdown.current;

      if (dropdownActive === true && e.target !== dropdown) {
        this.setState({ dropdownActive: false });
      }
    });
  };

  render(): ReactNode {
    const { data } = this.props;
    const { dropdownActive } = this.state;

    return (
      <Wrapper
        id="action-bar-options-cog"
        ref={this.optionsDropdown}
        onClick={this.handleOptionsCog}
        active={dropdownActive}
      >
        {dropdownActive && (
          <DropdownWrapper>
            <DropdownList>
              {data &&
                data.map((dropdownItem) => (
                  <DropdownListItem
                    key={dropdownItem.id}
                    onClick={dropdownItem.action}
                  >
                    {dropdownItem.label}
                  </DropdownListItem>
                ))}
            </DropdownList>
          </DropdownWrapper>
        )}
      </Wrapper>
    );
  }
}

export default ActionBarOptionsCog;
